import { IRoute } from "shared/interface/types";
import { PersonalAccidentOrderRoutes } from "./healthOrderRoute";
import { healthShelfPlanB2CRoutes } from "./shelfPlanRoute/B2CRoute";

export const PersonalAccidentRoutes: IRoute[] = [...PersonalAccidentOrderRoutes, ...healthShelfPlanB2CRoutes];
